import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const GermanyFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 513 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_103_3860)">
      <path d="M0.5 341.3H512.5V512H0.5V341.3Z" fill="#FFCE00" />
      <path d="M0.5 0H512.5V170.7H0.5V0Z" fill="black" />
      <path d="M0.5 170.7H512.5V341.3H0.5V170.7Z" fill="#DD0000" />
    </g>
    <defs>
      <clipPath id="clip0_103_3860">
        <rect
          width="512"
          height="512"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
